import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {FiltersConfigSearchValueObject} from '../ValueObjects/FiltersConfigSearchValueObject.js'

class GetFiltersConfigSearchUseCase extends UseCase {
  static create() {
    return new GetFiltersConfigSearchUseCase()
  }

  @tracer({metric: 'GetFiltersConfigSearchUseCase#execute'})
  @inlineError
  async execute({search, type}) {
    const filtersConfigValueObject = FiltersConfigSearchValueObject.createFromSearch({search, type})
    return filtersConfigValueObject.value
  }
}

export default GetFiltersConfigSearchUseCase.create
